import { createHead } from "unhead/dist/client.mjs";

// Unhead 客户端实例，路由与 store 通过 applyPageHead 写入 head
export const head = createHead();

/**
 * 通过 Unhead 设置页面 title、description、canonical
 * applyPageHead - 应用页面头部 SEO
 */
export function applyPageHead({ title, description, canonical } = {}) {
  const payload = {};
  if (title !== undefined) {
    payload.title = title;
  }
  if (description !== undefined) {
    payload.meta = [{ name: "description", content: description }];
  }
  if (canonical) {
    payload.link = [{ rel: "canonical", href: canonical }];
  }
  if (Object.keys(payload).length > 0) {
    head.push(payload);
  }
}
